export const platformTerms =
    'In its current release, the ODEON Platform does not impose any additional terms in comparison to the platform terms of use.';
